import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Field, formValueSelector } from 'redux-form';

import IconButton from 'material-ui/IconButton';
import CreateIcon from 'material-ui/svg-icons/content/create';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import ControlPointIcon from 'material-ui/svg-icons/image/control-point';

import { changePort } from 'actions/regions/ports';
import AddDetail from './AddDetail';
import EditDetail from './EditDetail';
import { formName } from 'data/formNames';

const styles = {
    icon: { iconStyle: { color: '#00bcd4' } },
};

class Details extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openEditDialog: false,
            openAddDialog: false,
            current: {
                field: '',
                min: 0,
                max: 0,
            },
        };

        this.toggleEditDialog = this.toggleEditDialog.bind(this);
        this.toggleAddDialog = this.toggleAddDialog.bind(this);
        this.addCapacity = this.addCapacity.bind(this);
    }

    addCapacity() {
        const { fields } = this.props;

        fields.push({
            name: '',
            value: '',
        });

        this.toggleAddDialog({
            field: `${fields.name}[${fields.length}]`,
        });
    }

    toggleAddDialog(current = this.state.current) {
        this.setState({
            openAddDialog: !this.state.openAddDialog,
            current,
        });
    }

    toggleEditDialog(current = this.state.current) {
        this.setState({
            openEditDialog: !this.state.openEditDialog,
            current,
        });
    }

    render() {
        const { openEditDialog, openAddDialog, current } = this.state;
        const {
            fields, name, port, max, min, 
        } = this.props;

        return (
            <Fragment>
                {
                    fields.map((detail, index) => (<Fragment key={index}>
                        <div className='item middle-xs'>
                            <Field
                                component={({
                                    input, label, type, port, detail, meta: { touched, error }, 
                                }) => (
                                    <div className="count">
                                        {`${_.get(port, detail) ? _.get(port, detail) : ''} mt: `}
                                        <span className="error">
                                            {`${error || ''}`}
                                        </span>
                                    </div>
                                )}
                                name={`${detail}.value`}
                                props={{ port, detail: `${detail}.value` }}
                            />

                            <Field
                                component={({
                                    input, label, type, port, detail, meta: { touched, error }, 
                                }) => (
                                    <div className="name">
                                        {`${_.get(port, detail) ? _.get(port, detail) : ''} `}
                                        <span className="error">
                                            {`${error || ''}`}
                                        </span>
                                    </div>
                                )}
                                name={`${detail}.name`}
                                props={{ port, detail: `${detail}.name` }}
                            />

                            <div className='edit'>
                                <div className='icon edit-icon'>
                                    <IconButton
                                        iconStyle={styles.icon.iconStyle}
                                        onClick={() => {
                                            this.toggleEditDialog({
                                                field: detail,
                                            });
                                        }}
                                    >
                                        <CreateIcon />
                                    </IconButton>
                                </div>

                                <div className='icon delete-icon'>
                                    <IconButton
                                        iconStyle={styles.icon.iconStyle}
                                        onClick={() => {
                                            fields.remove(index);
                                        }}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                                                   </Fragment>))
                }

                <AddDetail
                    open={openAddDialog}
                    toggle={this.toggleAddDialog}
                    field={current.field}
                    fields={fields}
                    name={name}
                    min={min}
                    max={max}
                />

                <EditDetail
                    open={openEditDialog}
                    toggle={this.toggleEditDialog}
                    field={current.field}
                    name={name}
                    min={min}
                    max={max}
                />

                <div className='row add-capacity'>
                    <div className='col-xs-9' />
                    <div className='col-xs-3 middle-xs end-xs'>
                        <div className='text'>Add capacity</div>

                        <IconButton
                            iconStyle={styles.icon.iconStyle}
                            onClick={this.addCapacity}
                        >
                            <ControlPointIcon />
                        </IconButton>
                    </div>
                </div>
            </Fragment>
        );
    }
}

Details.propTypes = {

};

Details.defaultProps = {

};

const selector = formValueSelector(formName.portUpdate);
export default connect(
    (state, ownProps) => ({
        ...ownProps,
        liftsCranes: selector(state, 'liftsCranes'),
        port: state.port,
    }),
    dispatch => bindActionCreators({
        changePort,
    }, dispatch),
)(Details);



// WEBPACK FOOTER //
// ./app/components/Regions/Port/LiftAndCranes/Details.jsx